<!-- Header & Filters Container -->
<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">ITINERARIOS</h1>
            <p class="page-subtitle">
                Explora y gestiona las salidas y llegadas de naves
            </p>
        </div>
        <div class="header-logo">
            <img src="assets/images/logos/logo-opb-azul.png" alt="OPB" />
        </div>
    </div>

    <!-- Filtros de búsqueda -->
    <mat-card class="filters-card">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>filter_list</mat-icon>
                Filtros de Búsqueda
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="filters-section">
                <div class="filters-grid filters-grid-50">
                    <!-- Primera fila: POL, POD, Naviera, Nave -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Puerto Embarque (POL)</mat-label>
                        <input
                            matInput
                            [formControl]="filtroPol"
                            [matAutocomplete]="autoPol"
                            placeholder="Buscar puerto"
                            inputmode="search"
                        />
                        <mat-autocomplete #autoPol="matAutocomplete">
                            <mat-option [value]="''" class="option-all"
                                >Todos los puertos</mat-option
                            >
                            <mat-option
                                *ngFor="let port of filteredPolOptions"
                                [value]="port.name"
                            >
                                {{ port.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>anchor</mat-icon>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Puerto Descarga (POD) *</mat-label>
                        <input
                            matInput
                            [formControl]="filtroPod"
                            [matAutocomplete]="autoPod"
                            placeholder="Buscar puerto"
                            inputmode="search"
                        />
                        <mat-autocomplete #autoPod="matAutocomplete">
                            <mat-option [value]="''" class="option-all"
                                >Todos los puertos</mat-option
                            >
                            <mat-option
                                *ngFor="let port of filteredPodOptions"
                                [value]="port.name"
                            >
                                {{ port.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>location_on</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Naviera</mat-label>
                        <input
                            matInput
                            [formControl]="filtroCarrier"
                            [matAutocomplete]="autoCarrier"
                            placeholder="Buscar naviera"
                            inputmode="search"
                        />
                        <mat-autocomplete #autoCarrier="matAutocomplete">
                            <mat-option [value]="''" class="option-all"
                                >Todas las navieras</mat-option
                            >
                            <mat-option
                                *ngFor="let carrier of filteredCarrierOptions"
                                [value]="carrier.name"
                            >
                                {{ carrier.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>directions_boat</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Nave</mat-label>
                        <input
                            matInput
                            [formControl]="filtroNave"
                            [matAutocomplete]="autoNave"
                            placeholder="Buscar nave"
                            inputmode="search"
                        />
                        <mat-autocomplete #autoNave="matAutocomplete" (optionSelected)="onNaveSelected($event)">
                            <mat-option [value]="''" class="option-all"
                                >Todas las naves</mat-option
                            >
                            <mat-option
                                *ngFor="let vessel of filteredVesselsOptions"
                                [value]="vessel.name"
                            >
                                {{ vessel.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>sailing</mat-icon>
                    </mat-form-field>

                    <!-- Segunda fila: Rango ETD y ETA - Se requiere al menos una fecha -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>ETD Desde</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerEtdDesde"
                            [formControl]="filtroEtdDesde"
                            placeholder="Fecha salida desde"
                            inputmode="none"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerEtdDesde"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerEtdDesde></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>ETD Hasta</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerEtdHasta"
                            [formControl]="filtroEtdHasta"
                            placeholder="Fecha salida hasta"
                            inputmode="none"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerEtdHasta"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerEtdHasta></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>ETA Desde</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerEtaDesde"
                            [formControl]="filtroEtaDesde"
                            placeholder="Fecha llegada desde"
                            inputmode="none"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerEtaDesde"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerEtaDesde></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>ETA Hasta</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerEtaHasta"
                            [formControl]="filtroEtaHasta"
                            placeholder="Fecha llegada hasta"
                            inputmode="none"
                            readonly
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerEtaHasta"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerEtaHasta></mat-datepicker>
                        <mat-hint *ngIf="!hasAnyDateFilter()"
                            >* Se requiere al menos una fecha</mat-hint
                        >
                    </mat-form-field>

                    <!-- Tercera fila: Servicio -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Servicio</mat-label>
                        <mat-select [formControl]="filtroServicio">
                            <mat-option
                                *ngFor="let opt of servicioOptions"
                                [value]="opt.value"
                            >
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>category</mat-icon>
                    </mat-form-field>
                </div>

                <!-- Botones de acción -->
                <div class="filter-actions">
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="aplicarFiltros()"
                        [disabled]="isLoading || !hasRequiredFilters()"
                        [matTooltip]="
                            hasRequiredFilters()
                                ? 'Buscar con los filtros aplicados'
                                : 'Complete POD y al menos una fecha para buscar'
                        "
                    >
                        Buscar
                    </button>
                    <button
                        mat-raised-button
                        color="warn"
                        (click)="limpiarFiltros()"
                        [disabled]="!hasActiveFilters() || isLoading"
                        matTooltip="Limpiar todos los filtros"
                    >
                        <mat-icon>clear</mat-icon>
                        Limpiar
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Results Count -->
    <div class="results-meta">
        <span class="count">{{ totalRegistros }} resultados encontrados</span>
        <div class="actions">
            <button
                mat-raised-button
                color="primary"
                (click)="exportarExcel()"
                [disabled]="isLoading || totalRegistros === 0"
                matTooltip="Exportar datos actuales a Excel"
            >
                <mat-icon>download</mat-icon>
                Excel
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div class="state-container" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Error State -->
    <div class="state-container error" *ngIf="hasError && !isLoading">
        <i class="ri-error-warning-line"></i>
        <p>{{ errorMessage }}</p>
        <button class="retry-btn" (click)="buscarItinerarios()">
            Reintentar
        </button>
    </div>

    <!-- Cards List -->
    <div class="cards-grid" *ngIf="!isLoading && !hasError">
        <!-- Single Card Item -->
        <div class="itinerario-card" *ngFor="let item of dataSource.data">
            <!-- New Sidebar Layout (Ticket Style with Centered Header) -->
            <div class="card-ticket-container">
                <!-- LEFT SIDEBAR: Brand & Vessel -->
                <div class="card-sidebar">
                    <div class="carrier-brand">
                        <span class="carrier-short">{{
                            item.carrierName || '--'
                        }}</span>
                        <span
                            class="carrier-full"
                            *ngIf="
                                item.carrierFullName &&
                                item.carrierFullName !== item.carrierName
                            "
                            >{{ item.carrierFullName }}</span
                        >
                    </div>

                    <div class="vessel-voyage-section">
                        <div class="info-row" matTooltip="Nave">
                            <mat-icon class="icon-tiny"
                                >directions_boat</mat-icon
                            >
                            <span class="value">{{
                                item.vesselName || '--'
                            }}</span>
                        </div>
                        <div class="info-row" matTooltip="Viaje">
                            <mat-icon class="icon-tiny"
                                >confirmation_number</mat-icon
                            >
                            <span class="value">{{
                                item.voyageNumber || '--'
                            }}</span>
                        </div>
                    </div>
                    <!-- Status moved to center, removed from here -->
                </div>

                <!-- CENTER PANEL: Route Only -->
                <div class="card-center-panel">
                    <!-- New Layout: Route spans full width -->
                    <div class="panel-body-new">
                        <!-- Top Row: Destination info on right -->
                        <div class="top-row">
                            <div class="spacer"></div>
                            <div class="destination-info">
                                <span
                                    class="date-large"
                                    matTooltip="Fecha Estimada de Arribo (ETA)"
                                    >{{ formatDisplayDate(item.eta) }}</span
                                >
                                <span class="port-name">{{
                                    item.podName
                                }}</span>
                            </div>
                        </div>

                        <!-- Middle Row: Full Width Route Timeline -->
                        <div class="route-row">
                            <div class="route-timeline-full">
                                <!-- Before POL indicator (badge for consistency) -->
                                <!-- Before POL indicator -->
                                <ng-container
                                    *ngIf="
                                        getRouteSegments(item.route).beforePol
                                            .length > 0
                                    "
                                >
                                    <!-- Case > 1: Show Badge -->
                                    <ng-container
                                        *ngIf="
                                            getRouteSegments(item.route)
                                                .beforePol.length > 1
                                        "
                                    >
                                        <span
                                            class="before-pol-badge clickable-badge"
                                            [matMenuTriggerFor]="stopsMenu"
                                            [matMenuTriggerData]="{
                                                stops: getRouteSegments(
                                                    item.route
                                                ).beforePol,
                                                title: 'Paradas previas'
                                            }"
                                            matTooltip="Click para ver detalle"
                                            matTooltipPosition="above"
                                        >
                                            +{{
                                                getRouteSegments(item.route)
                                                    .beforePol.length
                                            }}
                                        </span>
                                        <span
                                            class="route-line inactive-line before-pol-line"
                                        ></span>
                                    </ng-container>

                                    <!-- Case == 1: Show visible dot -->
                                    <ng-container
                                        *ngIf="
                                            getRouteSegments(item.route)
                                                .beforePol.length === 1
                                        "
                                    >
                                        <ng-container
                                            *ngFor="
                                                let stop of getRouteSegments(
                                                    item.route
                                                ).beforePol
                                            "
                                        >
                                            <span
                                                class="route-dot inactive-dot"
                                                [matTooltip]="
                                                    stop.portName +
                                                    ' (' +
                                                    (stop.eta ||
                                                        stop.etd ||
                                                        '-') +
                                                    ')'
                                                "
                                                matTooltipPosition="above"
                                                matTooltipClass="route-tooltip"
                                            >
                                            </span>
                                        </ng-container>
                                        <span
                                            class="route-line inactive-line"
                                        ></span>
                                    </ng-container>
                                </ng-container>

                                <!-- POL Marker -->
                                <div
                                    class="route-anchor pol"
                                    *ngIf="getPolStop(item.route) as polStop"
                                >
                                    <span class="anchor-label">POL</span>
                                    <span
                                        class="anchor-dot"
                                        [matTooltip]="
                                            polStop.portName +
                                            ' (' +
                                            (polStop.etd || '-') +
                                            ')'
                                        "
                                        matTooltipPosition="above"
                                        matTooltipClass="route-tooltip"
                                    >
                                    </span>
                                </div>

                                <!-- Intermediate Stops -->
                                <div class="route-intermediate">
                                    <span class="route-line active-line"></span>

                                    <!-- Visible Intermediate Dots -->
                                    <ng-container
                                        *ngFor="
                                            let stop of getVisibleIntermediateStops(
                                                item.route
                                            )
                                        "
                                    >
                                        <span
                                            class="route-dot intermediate-dot"
                                            [matTooltip]="
                                                stop.portName +
                                                ' (' +
                                                (stop.eta || stop.etd || '-') +
                                                ')'
                                            "
                                            matTooltipPosition="above"
                                            matTooltipClass="route-tooltip"
                                        >
                                        </span>
                                    </ng-container>

                                    <!-- Hidden stops indicator -->
                                    <span
                                        class="more-stops-badge clickable-badge"
                                        *ngIf="
                                            getHiddenStopsCount(item.route) > 0
                                        "
                                        [matMenuTriggerFor]="stopsMenu"
                                        [matMenuTriggerData]="{
                                            stops: getHiddenStops(item.route),
                                            title: 'Paradas intermedias'
                                        }"
                                        matTooltip="Click para ver detalle"
                                        matTooltipPosition="above"
                                    >
                                        +{{ getHiddenStopsCount(item.route) }}
                                    </span>
                                </div>

                                <!-- POD Marker -->
                                <div
                                    class="route-anchor pod"
                                    *ngIf="getPodStop(item.route) as podStop"
                                >
                                    <span
                                        class="anchor-dot"
                                        [matTooltip]="
                                            podStop.portName +
                                            ' (' +
                                            (podStop.eta || '-') +
                                            ')'
                                        "
                                        matTooltipPosition="above"
                                        matTooltipClass="route-tooltip"
                                    >
                                    </span>
                                    <span class="anchor-label">POD</span>
                                </div>

                                <!-- After POD indicator -->
                                <!-- After POD indicator -->
                                <ng-container
                                    *ngIf="
                                        getRouteSegments(item.route).afterPod
                                            .length > 0
                                    "
                                >
                                    <!-- Case > 1: Show Badge -->
                                    <ng-container
                                        *ngIf="
                                            getRouteSegments(item.route)
                                                .afterPod.length > 1
                                        "
                                    >
                                        <span
                                            class="route-line inactive-line after-pod-line"
                                        ></span>
                                        <span
                                            class="after-pod-badge clickable-badge"
                                            [matMenuTriggerFor]="stopsMenu"
                                            [matMenuTriggerData]="{
                                                stops: getRouteSegments(
                                                    item.route
                                                ).afterPod,
                                                title: 'Paradas posteriores'
                                            }"
                                            matTooltip="Click para ver detalle"
                                            matTooltipPosition="above"
                                        >
                                            +{{
                                                getRouteSegments(item.route)
                                                    .afterPod.length
                                            }}
                                        </span>
                                    </ng-container>

                                    <!-- Case == 1: Show visible dot -->
                                    <ng-container
                                        *ngIf="
                                            getRouteSegments(item.route)
                                                .afterPod.length === 1
                                        "
                                    >
                                        <span
                                            class="route-line inactive-line after-pod-line"
                                        ></span>
                                        <ng-container
                                            *ngFor="
                                                let stop of getRouteSegments(
                                                    item.route
                                                ).afterPod
                                            "
                                        >
                                            <span
                                                class="route-dot inactive-dot"
                                                [matTooltip]="
                                                    stop.portName +
                                                    ' (' +
                                                    (stop.eta ||
                                                        stop.etd ||
                                                        '-') +
                                                    ')'
                                                "
                                                matTooltipPosition="above"
                                                matTooltipClass="route-tooltip"
                                            >
                                            </span>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>

                        <!-- Bottom Row: Origin info on left, transit/button centered -->
                        <div class="bottom-row">
                            <div class="origin-info">
                                <span
                                    class="date-large"
                                    matTooltip="Fecha Estimada de Zarpe (ETD)"
                                    >{{ formatDisplayDate(item.etd) }}</span
                                >
                                <span class="port-name">{{
                                    item.polName
                                }}</span>
                            </div>

                            <div class="transit-center">
                                <div class="transit-content">
                                    <span
                                        class="transit-days"
                                        *ngIf="item.transitTime > 0"
                                        >{{ item.transitTime }} días</span
                                    >
                                    <span
                                        class="transit-days empty"
                                        *ngIf="
                                            !item.transitTime ||
                                            item.transitTime === 0
                                        "
                                        >--</span
                                    >

                                    <!-- Ver ruta link -->
                                    <div
                                        class="view-route-link"
                                        *ngIf="
                                            item.route && item.route.length > 2
                                        "
                                        [matMenuTriggerFor]="routeDetailsMenu"
                                    >
                                        <mat-icon>route</mat-icon>
                                        <span>Ver ruta completa</span>
                                    </div>
                                </div>

                                <!-- Full Route Popover -->
                                <mat-menu
                                    #routeDetailsMenu="matMenu"
                                    class="route-details-popover"
                                    xPosition="after"
                                    yPosition="above"
                                >
                                    <div
                                        class="stops-popover-content"
                                        (click)="$event.stopPropagation()"
                                    >
                                        <div class="popover-header">
                                            <mat-icon>route</mat-icon>
                                            <span
                                                >Ruta completa ({{
                                                    item.route?.length || 0
                                                }}
                                                paradas)</span
                                            >
                                        </div>
                                        <div class="popover-list">
                                            <div
                                                class="stop-item"
                                                *ngFor="
                                                    let stop of item.route;
                                                    let last = last
                                                "
                                                [class.is-pol]="stop.isPol"
                                                [class.is-pod]="stop.isPod"
                                            >
                                                <div
                                                    class="stop-dot"
                                                    [class.anchor]="
                                                        stop.isPol || stop.isPod
                                                    "
                                                ></div>
                                                <div class="stop-info">
                                                    <div class="stop-name-row">
                                                        <span
                                                            class="stop-name"
                                                            >{{
                                                                stop.portName
                                                            }}</span
                                                        >
                                                        <span
                                                            class="pol-badge"
                                                            *ngIf="stop.isPol"
                                                            >POL</span
                                                        >
                                                        <span
                                                            class="pod-badge"
                                                            *ngIf="stop.isPod"
                                                            >POD</span
                                                        >
                                                    </div>
                                                    <span class="stop-date">{{
                                                        stop.eta ||
                                                            stop.etd ||
                                                            '-'
                                                    }}</span>
                                                </div>
                                                <div
                                                    class="stop-line"
                                                    *ngIf="!last"
                                                ></div>
                                            </div>
                                        </div>
                                        <div
                                            class="scroll-indicator"
                                            *ngIf="
                                                item.route &&
                                                item.route.length > 5
                                            "
                                        >
                                            <mat-icon
                                                >keyboard_arrow_down</mat-icon
                                            >
                                            <span>Desliza para ver más</span>
                                        </div>
                                    </div>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RIGHT PANEL: Action -->
                <div class="card-action-panel">
                    <button class="detail-btn" (click)="navigateToDetail(item)">
                        <mat-icon>calendar_today</mat-icon>
                        VER DETALLE
                    </button>
                    <button
                        class="ie-btn"
                        *ngIf="canViewInstructivoButton"
                        (click)="openWizardIE(item)"
                        [disabled]="!item.voyageId"
                        matTooltip="Instructivos de Embarque"
                    >
                        <mat-icon>description</mat-icon>
                        INSTRUCTIVOS
                    </button>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div
            class="empty-state"
            *ngIf="dataSource.data.length === 0 && !showRequiredFiltersMessage"
        >
            <i class="ri-search-2-line"></i>
            <h3>Sin resultados</h3>
            <p>Intenta ajustar los filtros de búsqueda</p>
        </div>

        <!-- Initial State - Required Filters Message -->
        <div
            class="initial-state"
            *ngIf="
                showRequiredFiltersMessage &&
                dataSource.data.length === 0 &&
                !isLoading
            "
        >
            <mat-icon>filter_alt</mat-icon>
            <h3>Filtros Requeridos</h3>
            <p>
                Ingrese <strong>POD</strong> y al menos una fecha (<strong
                    >ETD</strong
                >
                o <strong>ETA</strong>) para buscar itinerarios
            </p>
        </div>
    </div>
    <!-- End cards-grid -->

    <!-- SHARED STOPS MENU POPOVER -->
    <mat-menu
        #stopsMenu="matMenu"
        class="route-details-popover"
        xPosition="after"
        yPosition="above"
    >
        <ng-template matMenuContent let-stops="stops" let-title="title">
            <div
                class="stops-popover-content"
                (click)="$event.stopPropagation()"
            >
                <div class="popover-header" *ngIf="title">
                    <mat-icon>linear_scale</mat-icon>
                    <span>{{ title }}</span>
                </div>
                <div class="popover-list">
                    <div
                        class="stop-item"
                        *ngFor="let stop of stops; let last = last"
                    >
                        <div class="stop-dot"></div>
                        <div class="stop-info">
                            <span class="stop-name">{{ stop.portName }}</span>
                            <span class="stop-date">{{
                                stop.eta || stop.etd || '-'
                            }}</span>
                        </div>
                        <div class="stop-line" *ngIf="!last"></div>
                    </div>
                </div>
            </div>
        </ng-template>
    </mat-menu>

    <mat-paginator
        *ngIf="totalRegistros > 0"
        [length]="totalRegistros"
        [pageSize]="elementosPorPagina"
        [pageIndex]="paginaActual - 1"
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="onPageChange($event)"
    >
    </mat-paginator>
</div>
